import { z } from 'zod';

import { restAPI } from '../rest-api';

import { stripUndefined } from '~/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stripNull = (obj: { [key: string]: any }): { [key: string]: any } => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: { [key: string]: any } = {};
    for (const key in obj) {
        if (obj[key] !== null) {
            result[key] = obj[key];
        }
    }
    return result;
};

const toParams = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawParams: Record<string, any>,
    options?: {
        stripNull?: boolean;
    },
) => {
    const { stripNull: shouldStripNull = true } = options ?? {};
    const paramArg = rawParams;
    let parsed = paramArg ?? {};
    parsed = stripUndefined(paramArg);
    if (shouldStripNull) {
        parsed = stripNull(parsed);
    }

    return new URLSearchParams(parsed);
};


export enum PieChartMetricTypes {
    SEVERITY = 'Severity',
    CONFIDENTIALITY = 'Confidentiality',
    AGE_OF_REPORT = 'Age of Report',
    FINDINGS = 'Findings',
    CHECK_BACK_RATIO = 'Check Back Ratio',
}



export const pieChartSchema = z.object({
    'count': z.coerce.number(),
}).passthrough().transform((value) => {
    /**
     * this should hold all the possible key values for the labels of the response
     */
    const labelKeys = ['severity', 'label', 'reporting_preference'];
    const foundKey = Object.keys(value).find(key => labelKeys.includes(key));
    if (foundKey) {
        return {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            label: value[foundKey],
            ...value,
        } as { label: string, count: number };
    }
    return value as { label: string, count: number };
});
export type PieChartValue = typeof pieChartSchema['_output'];

const pieChartMetricParamsSchema = z.object({
    filter_by: z.string(),
    tenant_id: z.coerce.number().optional(),
    date: z.string(),
    date_end: z.string(),
    intake_channel: z.number().nullable(),
});

const endpoints = restAPI.injectEndpoints({
    endpoints: (builder) => ({
        pieChartMetrics: builder.query<Array<PieChartValue>, { metricType: PieChartMetricTypes; params?: z.infer<typeof pieChartMetricParamsSchema> }>({
            query(arg) {
                const url: Record<PieChartMetricTypes, string> = {
                    'Severity': '/dashboard/reports-by-severity',
                    'Confidentiality': '/dashboard/reports-by-preference',
                    'Age of Report': '/dashboard/request-age-of-reports',
                    'Findings': '/dashboard/reports-cases-by-findings',
                    'Check Back Ratio': '/dashboard/check-back-ratio',
                };
                const params = Object.fromEntries(toParams(arg.params ?? {}).entries());
                return {
                    url: url[arg.metricType],
                    params,
                };
            },
            transformResponse(response) {
                return pieChartSchema.array().parse(response);
            },
        }),
    }),
    overrideExisting: false,
});

export const MetricsService = endpoints;
